import { useDecision } from '@optimizely/react-sdk'

export const MENU_EXPERIENCE_SEARCH_FLAG = 'turnips_ofx_menu_search_experience_api'

export const useIsMenuExperienceSearchEnabled = () => {
  const [decision] = useDecision(MENU_EXPERIENCE_SEARCH_FLAG)

  return decision?.variationKey === 't1'
}
